import { render, staticRenderFns } from "./FAQNew.vue?vue&type=template&id=10931eb2&"
import script from "./FAQNew.vue?vue&type=script&lang=js&"
export * from "./FAQNew.vue?vue&type=script&lang=js&"
import style0 from "./FAQNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports